import { dataRecommendSquareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconRecommendSquareSolid = /*#__PURE__*/createIcon(dataRecommendSquareSolid)
export default IconRecommendSquareSolid
